<template>
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.333252" width="48" height="48" rx="8" :fill="color ? color : '#10233E'" />
    <path d="M12.802 22.1852H32.4296V25.8218H12.802V22.1852Z" fill="white" />
    <path
      d="M35.9067 14.5863C35.5958 14.1225 35.1603 13.8392 34.6804 13.7886L17.7794 12.0081C17.2995 11.9575 16.8329 12.1458 16.4653 12.538C16.0991 12.9288 15.8749 13.4754 15.8336 14.0779L15.4936 18.1029H14.1358C13.1419 18.1029 12.3333 19.1232 12.3333 20.3772V33.7257C12.3333 34.9797 13.1419 36 14.1358 36H31.0957C32.0897 36 32.8984 34.9797 32.8984 33.7257V31.5603L33.5002 31.6237C33.5509 31.629 33.6014 31.6317 33.6515 31.6317C34.5781 31.6317 35.368 30.7322 35.4465 29.5465L36.3269 16.2444C36.3669 15.6389 36.2177 15.0501 35.9067 14.5863ZM31.9609 33.7257C31.9609 34.3275 31.5728 34.8172 31.0957 34.8172H14.1358C13.6588 34.8172 13.2707 34.3275 13.2707 33.7257V20.3772C13.2707 19.7754 13.6588 19.2857 14.1358 19.2857H31.0957C31.5727 19.2857 31.9609 19.7754 31.9609 20.3772V33.7257ZM35.3926 16.1459L34.5123 29.4481C34.4725 30.0478 34.0534 30.4952 33.5782 30.445L32.8984 30.3733V20.3772C32.8984 19.1232 32.0897 18.1029 31.0957 18.1029H16.4364L16.7663 14.1972C16.7667 14.1927 16.767 14.1882 16.7673 14.1837C16.807 13.5839 17.2259 13.1366 17.7014 13.1868L34.6025 14.9674C34.8328 14.9916 35.0418 15.1276 35.191 15.3502C35.3402 15.5728 35.4118 15.8553 35.3926 16.1459Z"
      fill="white"
    />
    <path
      d="M29.9991 28.1715H25.4878C25.2289 28.1715 25.019 28.4363 25.019 28.763V32.4764C25.019 32.8031 25.2289 33.0679 25.4878 33.0679H29.9991C30.258 33.0679 30.4679 32.8031 30.4679 32.4764V28.763C30.4679 28.4363 30.258 28.1715 29.9991 28.1715ZM29.5304 31.885H25.9565V29.3544H29.5304V31.885Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
    props: ['color']
};
</script>

<style lang="scss" scoped></style>
